export const TRACKING_SITE_AREA = 'cable';
export const TRACKING_BUSINESS_TRANSACTION_TYPE = 'cable>internet & phone';
export const TRACKING_FLOW_TYPE = 'internet_telefon_flow';
export const TRACKING_AVC_FORM_NAME = 'product availability check';
export const TRACKING_TYPE_AVC = 'availability';
export const TRACKING_TYPE_CONTACT = 'contact';
export const TRACKING_PAGE_LEVEL_AVC = 'availability check';
export const TRACKING_ERROR_ACTION = 'displayed';
export const TRACKING_INTEREST_FIB = 'glassfiber interest';
export const TRACKING_ACTION_ENGAGE = 'engage';
export const TRACKING_ACTION_REVEAL = 'reveal';
export const TRACKING_LEGAL_OVERLAY_OPENING = 'legal notice tv connect products';
